/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iconik_Publish_Success_ConfirmInputs */

const en_iconik_publish_success_confirm = /** @type {(inputs: Iconik_Publish_Success_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ok`)
};

const fr_iconik_publish_success_confirm = /** @type {(inputs: Iconik_Publish_Success_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ok`)
};

const de_iconik_publish_success_confirm = /** @type {(inputs: Iconik_Publish_Success_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OK`)
};

const it_iconik_publish_success_confirm = /** @type {(inputs: Iconik_Publish_Success_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OK`)
};

const ru_iconik_publish_success_confirm = /** @type {(inputs: Iconik_Publish_Success_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Хорошо`)
};

const es_iconik_publish_success_confirm = /** @type {(inputs: Iconik_Publish_Success_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De acuerdo`)
};

const zh_cn2_iconik_publish_success_confirm = /** @type {(inputs: Iconik_Publish_Success_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`好的`)
};

const ja_iconik_publish_success_confirm = /** @type {(inputs: Iconik_Publish_Success_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`わかりました`)
};

const hi_iconik_publish_success_confirm = /** @type {(inputs: Iconik_Publish_Success_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ठीक है`)
};

const pt_pt2_iconik_publish_success_confirm = /** @type {(inputs: Iconik_Publish_Success_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OK`)
};

/**
* | output |
* | --- |
* | "Ok" |
*
* @param {Iconik_Publish_Success_ConfirmInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const iconik_publish_success_confirm = /** @type {((inputs?: Iconik_Publish_Success_ConfirmInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iconik_Publish_Success_ConfirmInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_iconik_publish_success_confirm(inputs)
	if (locale === "de") return de_iconik_publish_success_confirm(inputs)
	if (locale === "it") return it_iconik_publish_success_confirm(inputs)
	if (locale === "ru") return ru_iconik_publish_success_confirm(inputs)
	if (locale === "es") return es_iconik_publish_success_confirm(inputs)
	if (locale === "zh-CN") return zh_cn2_iconik_publish_success_confirm(inputs)
	if (locale === "ja") return ja_iconik_publish_success_confirm(inputs)
	if (locale === "hi") return hi_iconik_publish_success_confirm(inputs)
	if (locale === "pt-PT") return pt_pt2_iconik_publish_success_confirm(inputs)
	return en_iconik_publish_success_confirm(inputs)
});